import { render, staticRenderFns } from "./FooterRight.vue?vue&type=template&id=52d6303b&scoped=true"
import script from "./FooterRight.vue?vue&type=script&lang=js"
export * from "./FooterRight.vue?vue&type=script&lang=js"
import style0 from "./FooterRight.vue?vue&type=style&index=0&id=52d6303b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6303b",
  null
  
)

export default component.exports